<template>
  <div class="checkboxs">
    <div
      class="checkbox"
      v-for="label in refs"
      :key="label"
    >
      <input
        type="checkbox"
        :name="nameRef"
        :id="label"
        :value="label"
        :checked="searchArray.includes(label)"
        @change="$emit('update-search-array', {
          name: nameRef,
          checked: $event.target.checked,
          value: $event.target.value
        })"
      >
      <label :for="label">{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultipleChoiceCheckboxes',

  props: {
    nameRef: String,
    refs: Array,
    searchArray: Array
  }
}
</script>
